// src/App.tsx - Com lazy loading
import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router'
import { ThemeProvider } from '@/providers/ThemeProvider'
import { TRPCProvider } from '@/providers/trpc'
import Layout from './components/Layout'
import Login from './pages/Login'
import NotFound from './pages/NotFound'

// 🔥 Carregamento sob demanda
const Dashboard = lazy(() => import('./pages/Dashboard'))
const PDV = lazy(() => import('./pages/PDV'))
const PDVSupermercado = lazy(() => import('./pages/PDVSupermercado'))
const Comandas = lazy(() => import('./pages/Comandas'))
const Products = lazy(() => import('./pages/Products'))
const Customers = lazy(() => import('./pages/Customers'))
const Suppliers = lazy(() => import('./pages/Suppliers'))
const Stock = lazy(() => import('./pages/Stock'))
const Financial = lazy(() => import('./pages/Financial'))
const CashRegister = lazy(() => import('./pages/CashRegister'))
const Reports = lazy(() => import('./pages/Reports'))
const MobileWaiter = lazy(() => import('./pages/MobileWaiter'))
const CardapioPublico = lazy(() => import('./pages/CardapioPublico'))
const CardapioConfig = lazy(() => import('./pages/CardapioConfig'))
const PedidosOnline = lazy(() => import('./pages/PedidosOnline'))
const Entregador = lazy(() => import('./pages/Entregador.tsx'))
const PerfilCliente = lazy(() => import('./pages/PerfilCliente'))
const AcompanharPedido = lazy(() => import('./pages/AcompanharPedido'))
const BarcodePrint = lazy(() => import('./pages/BarcodePrint'))
const Logs = lazy(() => import('./pages/Logs'))
const Settings = lazy(() => import('./pages/Settings'))
const EmDesenvolvimento = lazy(() => import('./pages/EmDesenvolvimento'))

// Componente de loading
const PageLoader = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>
)

export default function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="pdv-theme">
      <TRPCProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Rotas Públicas */}
            <Route path="/cardapio/:slug" element={<CardapioPublico />} />
            <Route path="/acompanhar/:orderId" element={<AcompanharPedido />} />
            <Route path="/perfil" element={<PerfilCliente />} />
            <Route path="/login" element={<Login />} />

            {/* Rotas Protegidas */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="pdv" element={<PDV />} />
              <Route path="pdv-supermercado" element={<PDVSupermercado />} />
              <Route path="comandas" element={<Comandas />} />
              <Route path="produtos" element={<Products />} />
              <Route path="clientes" element={<Customers />} />
              <Route path="fornecedores" element={<Suppliers />} />
              <Route path="estoque" element={<Stock />} />
              <Route path="caixa" element={<CashRegister />} />
              <Route path="financeiro" element={<Financial />} />
              <Route path="relatorios" element={<Reports />} />
              <Route path="garcom" element={<MobileWaiter />} />
              <Route path="entregador" element={<Entregador />} />
              <Route path="configuracoes" element={<Settings />} />
              <Route path="logs" element={<Logs />} />
              <Route path="cardapio-config" element={<CardapioConfig />} />
              <Route path="pedidos-online" element={<PedidosOnline />} />
              <Route path="barcode-print" element={<BarcodePrint />} />
              <Route path="balancas" element={<EmDesenvolvimento title="Balancas" />} />
              <Route path="impressoras" element={<EmDesenvolvimento title="Impressoras Termicas" />} />
              <Route path="nota-fiscal" element={<EmDesenvolvimento title="Nota Fiscal" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </TRPCProvider>
    </ThemeProvider>
  )
}